import { Upload, FileText, User, Menu, Home } from "lucide-react";
import { useNavigate, useLocation } from "react-router-dom";
import { cn } from "@/lib/utils";

interface MobileBottomNavProps {
  onMoreClick: () => void;
}

export function MobileBottomNav({ onMoreClick }: MobileBottomNavProps) {
  const navigate = useNavigate();
  const location = useLocation();

  const tabs = [
    { icon: Home, label: 'Start', path: '/', action: undefined },
    { icon: Upload, label: 'Upload', path: '/speisekarte-hochladen', action: undefined },
    { icon: FileText, label: 'Ergebnisse', path: '/pruefungsergebnisse', action: undefined },
    { icon: User, label: 'Profil', path: '/profil', action: undefined },
    { icon: Menu, label: 'Mehr', path: undefined, action: 'more' as const }
  ];

  const isActive = (path?: string) => path && location.pathname === path;

  return (
    <nav className="mobile-bottom-nav">
      <div className="flex items-center justify-around h-full max-w-lg mx-auto">
        {tabs.map((tab) => (
          <button
            key={tab.label}
            onClick={() => tab.action === 'more' ? onMoreClick() : tab.path && navigate(tab.path)}
            className={cn(
              "bottom-nav-item",
              isActive(tab.path) && "active"
            )}
            aria-label={tab.label}
          >
            <tab.icon className="w-5 h-5" />
            <span className="text-[10px] mt-0.5 font-medium">{tab.label}</span>
          </button>
        ))}
      </div>
    </nav>
  );
}
